import React from "react";
import { Navigate } from "react-router-dom";
import { auth } from "./firebase";

export default function ProtectedRoute({ children }) {
  const user = auth.currentUser;

  // If no user is logged in → redirect to login
  if (!user) {
    return <Navigate to="/admin-login" replace />;
  }

  // Otherwise allow access
  return children;
}
